import React from 'react';

import MuiAlert from '@mui/material/Alert';
import { MdClose } from 'react-icons/md';
import CustomMultiSelect from 'src/utils/CustomMultiSelect';

import { ReactComponent as ArrowDownIcon } from 'src/Images/icons/common/arrowdown.svg';

export default function GoodsReceivedNotesMobile({ toggleGrnDrawer, logic }) {
  const {
    formData,
    themeColor,
    vehicleTrackingLineItemList,
    getStorageLocationOptionsForPlant,
    handleCheckboxClick,
    handleOnChange,
    handleSubmit,
    invalidFormSubmission,
    setInvalidFormSubmission,
  } = logic;
  // Card-based rendering for mobile
  const renderCards = () =>
    (vehicleTrackingLineItemList || []).map((itemObj) => (
      <div
        key={itemObj.id}
        className="main-vehicle-tracking-detail-form-component mb-2"
      >
        <div className="d-flex justify-space-between align-items-center timeline-header mb-2">
          <div className="text-lg text-bold">
            {itemObj.material_description}
          </div>
          <input
            type="checkbox"
            className="large-checkbox"
            checked={formData[itemObj.id]?.active || false}
            onChange={(e) => handleCheckboxClick(itemObj, e.target.checked)}
          />
        </div>
        <div className="form-line-item-container">
          <div className="text-md text-bold">
            <span>Plant Code:</span>{' '}
            <span className="left-padding text-semi-bold text-grey">
              {itemObj?.plant?.plant_code}
            </span>
          </div>

          <div className="text-md text-bold">
            <span>PO Number:</span>{' '}
            <span className="left-padding text-semi-bold text-grey">
              {itemObj?.purchase_order_number}
            </span>
          </div>

          <div className="text-md">
            <span className="text-bold">PO Quantity:</span>{' '}
            <span className="left-padding text-semi-bold text-grey">
              {itemObj?.receiving_quantity} {itemObj?.unit_of_measurement}
            </span>
          </div>
          <div className="d-flex flex-column flex-fill right-padding rg-5">
            <div className="text-md text-bold">Storage Location</div>
            <div className="input-wrapper">
              <CustomMultiSelect
                name="storage_location_id"
                isMulti={false}
                className="form-input-section p-0"
                classNamePrefix="react-select"
                placeholder="Select Storage Location"
                options={getStorageLocationOptionsForPlant(itemObj.plant.id)}
                onChange={(option) => {
                  handleOnChange(
                    {
                      target: {
                        name: 'storage_location_id',
                        value: option?.value || null,
                      },
                    },
                    itemObj.id,
                  );
                }}
                value={getStorageLocationOptionsForPlant(itemObj.plant.id).find(
                  (opt) =>
                    opt.value === formData[itemObj.id]?.storage_location_id,
                )}
              />
              <span className="form-input-section-icon p-2">
                <ArrowDownIcon className="icon-size-md" color="#9F9F9F" />
              </span>
            </div>
          </div>

          <div className="d-flex flex-column flex-fill right-padding rg-5">
            <div className="text-md text-bold">Batch Number</div>
            <input
              className="form-input-section"
              name="batch_number"
              type="text"
              value={formData[itemObj.id]?.batch_number || ''}
              onChange={(e) => handleOnChange(e, itemObj.id)}
              placeholder="Enter batch number"
            />
          </div>
        </div>
      </div>
    ));

  return (
    <div className="page-layout gap-2">
      {invalidFormSubmission && (
        <MuiAlert
          onClose={() => setInvalidFormSubmission(false)}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Please select a Storage Location for all selected items.
        </MuiAlert>
      )}
      <div className="div-flex-row div-space-between div-align-center border-bottom drawer-section-padding">
        <div className="div-space-between slider-padding">
          <span className="text-xxl text-bold">Goods Receipt</span>
        </div>
        <button
          className="icon-btn-none"
          onClick={() => toggleGrnDrawer(false)}
          aria-label="Close drawer"
        >
          <MdClose size="24px" />
        </button>
      </div>
      <div className="drawer-section-padding">
        <div className="line-item-container-padding">
          <div className="div-space-between div-align-center footer-content-for-page">
            <div className="text-md text-bold">Select Items & Storage</div>
            <button
              type="button"
              className={`vehicle-data-form-submit-btn theme-background-${themeColor}`}
              onClick={handleSubmit}
            >
              <span className="text-md">Submit</span>
            </button>
          </div>
        </div>
        <div
          className={`main-vehicle-tracking-detail-container theme-scrollable-container-${themeColor}`}
        >
          {renderCards()}
        </div>
      </div>
    </div>
  );
}
